/**
 * Amplitude rejects user_id / device_id shorter than minIdLength (default 5).
 * Prefix numeric Nurse Tools ids so `1` → `nurse_1` stays valid even if minIdLength is raised.
 */
export function toAmplitudeUserId(
  userId: string | null | undefined,
): string | undefined {
  const raw = userId?.trim();
  if (!raw) return undefined;
  if (raw.startsWith("nurse_")) return raw;
  return `nurse_${raw}`;
}
